





















































































































































































































import Vue from 'vue'
import _ from 'lodash'
import { ProfitCenter } from '@/model/companyStructure/ProfitCenter'
import { Department } from '@/model/companyStructure/Department'
import { PlanningGroup } from '@/model/companyStructure/PlanningGroup'
import { Employee } from '@/model/companyStructure/Employee'
import { CompanyStructure } from '@/types'
import { CompanyFilterValue, FetchShiftTemplateListPayload } from '@/types/payload'
import { ShiftTemplate } from '@/model/planning/ShiftTemplate'
import {
  COMPANY_FETCH_PROFIT_CENTER_CALENDAR_EVENTS,
  LOAD_SHIFT_TEMPLATE_LIST_FILTER,
  PLANNING_SEARCH_PROJECT_LIST,
  SCHEDULING_SET_PARAMETERS,
  SEARCH_ADDRESS_BY_ID,
  SEARCH_ADDRESS_LIST
} from '@/store/action-types'
import { CalendarEvent } from '@/model/planning/CalendarEvent'
import { SecurityData } from '@/model/SecurityData'
import { GET_SECURITY_LEVEL, SCHEDULING_GET_PARAMETERS } from '@/store/getter-types'
import { Address } from '@/model/planning/Address'
import * as securityService from '@/services/security-service'
import { SecurityArea, SecurityComponent } from '@/types/enums'
import { PlanungLookupProjekteResponse } from '@/types/service-response'
import { PlanningLookupProject } from '@/model/planning/PlanningLookupProject'

interface ComponentData {
  profitCenterList: Array<ProfitCenter>

  selectedProfitCenterId: number | undefined
  selectedDepartmentId: number | undefined
  selectedPlanningGroupId: number | undefined
  selectedEmployeeId: number | undefined
  shiftTemplateList: Array<ShiftTemplate>
  selectedShiftTemplateId: number | undefined
  selectedCalendarEventId: number | undefined
  calendarEventList: Array<CalendarEvent>
  panel: number[]
  selectedAddress: Address | undefined
  addressList: Array<Address>
  search: string | null
  isLoading: boolean
  selected: boolean
  selectedProject: PlanningLookupProject | null
  projectList: PlanningLookupProject[]
  projectLoading: boolean
  projectIsSelected: boolean
  foundProfitCenterData: ProfitCenter | undefined
}

export default Vue.extend({
  name: 'CompanyFilter',

  props: {
    companyStructure: {
      type: Object as () => CompanyStructure
    },
    selectedTemplateId: Number,
    securityData: {
      type: Array as () => Array<SecurityData>
    }
  },

  data (): ComponentData {
    return {
      profitCenterList: [],
      selectedProfitCenterId: undefined,
      selectedDepartmentId: undefined,
      selectedPlanningGroupId: undefined,
      selectedEmployeeId: undefined,
      shiftTemplateList: [],
      selectedShiftTemplateId: undefined,
      selectedCalendarEventId: undefined,
      calendarEventList: [],
      panel: [],
      selectedAddress: undefined,
      addressList: [],
      search: null,
      isLoading: false,
      selected: false,
      selectedProject: null,
      projectList: [],
      projectLoading: false,
      projectIsSelected: false,
      foundProfitCenterData: undefined
    }
  },

  computed: {
    departmentList (): Array<Department> {
      let list: Array<Department> = []

      if (this.selectedProfitCenterId) {
        list = this.companyStructure.departmentList
          .filter((item: Department) => item.profitCenterId === this.selectedProfitCenterId)
      }

      return list
    },

    planningGroupList (): Array<PlanningGroup> {
      let list: Array<PlanningGroup> = []

      if (this.selectedProfitCenterId && this.selectedDepartmentId) {
        list = this.companyStructure.planningGroupList
          .filter((item: PlanningGroup) => item.department === this.selectedDepartmentId)
      }

      return list
    },

    employeeList (): Array<Employee> {
      let list: Array<Employee> = []

      if (this.selectedProfitCenterId && this.selectedDepartmentId && this.selectedPlanningGroupId) {
        list = this.companyStructure.employeeList
          .filter((item: Employee) => item.planningGroupId === this.selectedPlanningGroupId)
      }

      //list.unshift(this.everyoneItem)

      return list
    },

    showProfitCenterSelect  (): boolean {
      return securityService.isVisible(SecurityArea.Planning, SecurityComponent.SelectBoxFiliale)
    },

    isDisabledProfitCenterSelect (): boolean {
      return securityService.isDisabled(SecurityArea.Planning, SecurityComponent.SelectBoxFiliale)
    },

    showDepartmentSelect  (): boolean {
      return securityService.isVisible(SecurityArea.Planning, SecurityComponent.SelectBoxAbteilung)
    },

    isDisabledDepartmentSelect (): boolean {
      return securityService.isDisabled(SecurityArea.Planning, SecurityComponent.SelectBoxAbteilung)
    },

    showShiftTemplateSelect  (): boolean {
      return securityService.isVisible(SecurityArea.Planning, SecurityComponent.SelectBoxSchichtvorlage)
    },

    isDisabledShiftTemplateSelect (): boolean {
      return securityService.isDisabled(SecurityArea.Planning, SecurityComponent.SelectBoxSchichtvorlage)
    },

    showAddressSelect  (): boolean {
      return securityService.isVisible(SecurityArea.Planning, SecurityComponent.SelectBoxAdress)
    },

    isDisabledAddressSelect (): boolean {
      return securityService.isDisabled(SecurityArea.Planning, SecurityComponent.SelectBoxAdress)
    },

    showProjectSelect  (): boolean {
      return securityService.isVisible(SecurityArea.Planning, SecurityComponent.SelectBoxProject)
    },

    isDisabledProjectSelect (): boolean {
      return securityService.isDisabled(SecurityArea.Planning, SecurityComponent.SelectBoxProject)
    },

    showCalendarEventSelect  (): boolean {
      return securityService.isVisible(SecurityArea.Planning, SecurityComponent.SelectBoxKalenderArt)
    },

    isDisabledCalendarEventSelect (): boolean {
      return securityService.isDisabled(SecurityArea.Planning, SecurityComponent.SelectBoxKalenderArt)
    },


    showExpansionPanel (): boolean {
      return !(!this.showProfitCenterSelect && !this.showDepartmentSelect && !this.showShiftTemplateSelect && !this.showAddressSelect && !this.showCalendarEventSelect);
    },

    foundAddressList (): Array<Address> {
      return this.addressList
    },

    securityLevel (): number | undefined {
      return this.$store.getters[GET_SECURITY_LEVEL]
    }
  },

  watch: {
    companyStructure (newVal): void {
      this.profitCenterList = _.cloneDeep(newVal.profitCenterList)
      const userId = this.$store.state.currentUser.id
      if (newVal) {
        const user: Employee | undefined = this.companyStructure.employeeList.find((item: Employee) => userId === item.id)
        if (user) {
          if(this.$route.path === '/planning') {
            let data: any = this.getRouteData()
            let schedulingData: any = this.$store.getters[SCHEDULING_GET_PARAMETERS]

            let companyData: any | undefined = undefined
            if(data && data.companyData) {
              companyData = data.companyData
            } else if(schedulingData && schedulingData.data && schedulingData.data.companyData) {
              companyData = schedulingData.data.companyData
            }

            this.selectedProfitCenterId = companyData && companyData.selectedProfitCenterId && newVal.profitCenterList.find((item: ProfitCenter) => companyData.selectedProfitCenterId === item.id) ? companyData.selectedProfitCenterId : this.$store.state.currentUser.defaultProfitCenter && newVal.profitCenterList.find((item: ProfitCenter) => this.$store.state.currentUser.defaultProfitCenter === item.id) ? newVal.profitCenterList.find((item: ProfitCenter) => this.$store.state.currentUser.defaultProfitCenter === item.id).id : newVal.profitCenterList.find((item: ProfitCenter) => user.profitCenter === item.id).id
            this.selectedDepartmentId = companyData && companyData.selectedDepartmentId && newVal.departmentList.find((item: Department) => companyData.selectedDepartmentId === item.id) ? companyData.selectedDepartmentId : this.$store.state.currentUser.defaultDepartment && newVal.departmentList.find((item: Department) => this.$store.state.currentUser.defaultDepartment === item.id) ? newVal.departmentList.find((item: Department) => this.$store.state.currentUser.defaultDepartment === item.id).id : newVal.departmentList.find((item: Department) => user.department === item.id).id
            this.foundProfitCenterData = companyData && companyData.selectedProfitCenterId && newVal.profitCenterList.find((item: ProfitCenter) => companyData.selectedProfitCenterId === item.id) ? newVal.profitCenterList.find((item: ProfitCenter) => companyData.selectedProfitCenterId === item.id) : this.$store.state.currentUser.defaultProfitCenter && newVal.profitCenterList.find((item: ProfitCenter) => this.$store.state.currentUser.defaultProfitCenter === item.id) ? newVal.profitCenterList.find((item: ProfitCenter) => this.$store.state.currentUser.defaultProfitCenter === item.id) : newVal.profitCenterList.find((item: ProfitCenter) => user.profitCenter === item.id)
            this.selectedShiftTemplateId = companyData && companyData.selectedShiftTemplateId ? companyData.selectedShiftTemplateId : undefined
            this.selectedCalendarEventId = companyData && companyData.selectedCalendarEventId ? companyData.selectedCalendarEventId : undefined
            const selectedAddressId = companyData && companyData.selectedAddressId ? companyData.selectedAddressId : undefined
            this.searchAddressById(selectedAddressId)
            if(!selectedAddressId) {
              this.selectDefaultAddress()
            }
            this.filterValueChange()
          } else {
            this.selectedProfitCenterId = this.$store.state.currentUser.defaultProfitCenter && newVal.profitCenterList.find((item: ProfitCenter) => this.$store.state.currentUser.defaultProfitCenter === item.id) ? newVal.profitCenterList.find((item: ProfitCenter) => this.$store.state.currentUser.defaultProfitCenter === item.id).id : newVal.profitCenterList.find((item: ProfitCenter) => user.profitCenter === item.id).id
            this.selectedDepartmentId = this.$store.state.currentUser.defaultDepartment && newVal.departmentList.find((item: Department) => this.$store.state.currentUser.defaultDepartment === item.id) ? newVal.departmentList.find((item: Department) => this.$store.state.currentUser.defaultDepartment === item.id).id : newVal.departmentList.find((item: Department) => user.department === item.id).id
            this.foundProfitCenterData = this.$store.state.currentUser.defaultProfitCenter && newVal.profitCenterList.find((item: ProfitCenter) => this.$store.state.currentUser.defaultProfitCenter === item.id) ? newVal.profitCenterList.find((item: ProfitCenter) => this.$store.state.currentUser.defaultProfitCenter === item.id) : newVal.profitCenterList.find((item: ProfitCenter) => user.profitCenter === item.id)
            this.selectDefaultAddress()
            this.filterValueChange()
          }
        }
      }
    },

    selectedTemplateId (newValue: number): void {
      if (newValue) {
        this.selectedShiftTemplateId = newValue
        this.onTemplateSelect(newValue)
      }
    },

    search (newVal: string | null): void {
      // Items have already been requested
      if (this.isLoading) return

      // Lazily load input items
      if(newVal && newVal.length > 2 && !this.selected) {
        this.searchAddress()
      }

      this.selected = false

      if (newVal === null) {
        this.selectDefaultAddress()
        this.selected = true
      }
    },

    selectedAddress (newVal: Address | null): void {
      if(newVal) {
        this.searchProject(newVal.id)
      }
    },
  },

  methods: {
    onProfitCenterChange (): void {
      this.selectedDepartmentId = undefined
      if(this.departmentList.length > 0) {
        this.selectedDepartmentId = this.departmentList[0].id
      }

      this.filterValueChange()
    },

    onDepartmentChange (): void {
      this.filterValueChange()
    },

    async filterValueChange (): Promise<void> {
      const filterValue: CompanyFilterValue = {
        profitCenter: _.find(this.companyStructure.profitCenterList, { id: this.selectedProfitCenterId }),
        department: _.find(this.companyStructure.departmentList, { id: this.selectedDepartmentId }),
        planningGroup: _.find(this.companyStructure.planningGroupList, { planningGroup: this.selectedPlanningGroupId }),
        employee: _.find(this.companyStructure.employeeList, { id: this.selectedEmployeeId })
      }

      let routeData: any = undefined
      if(this.$route.path === '/planning') {
        routeData = this.getRouteData()

        routeData.companyData = {
          selectedProfitCenterId: this.selectedProfitCenterId,
          selectedDepartmentId: this.selectedDepartmentId,
          selectedAddressId: this.selectedAddress ? this.selectedAddress.id : undefined,
          selectedProjectId: this.selectedProject ? this.selectedProject.id : null,
          selectedShiftTemplateId: this.selectedShiftTemplateId,
          selectedCalendarEventId: this.selectedCalendarEventId
        }

        this.$router.push({ name: 'planning', query: { data: JSON.stringify(routeData) } })

        let schedulingData: any = this.$store.getters[SCHEDULING_GET_PARAMETERS]
        schedulingData.companyData = routeData.companyData
        this.$store.dispatch(SCHEDULING_SET_PARAMETERS, schedulingData)
      }

      this.$emit('valueChanged', filterValue)

      if (this.selectedProfitCenterId) {
        let data: Array<CalendarEvent> = await this.$store.dispatch(COMPANY_FETCH_PROFIT_CENTER_CALENDAR_EVENTS,
          { profitCenterId: this.selectedProfitCenterId })

        if(this.securityLevel === 7) {
          data = data.filter((item: CalendarEvent) => item.eventId === 2)
        }

        this.calendarEventList = _.sortBy(data, [function(o) { return o.eventName.toLocaleLowerCase(); }])
        //this.selectDefaultAddress()
      }

      if (this.selectedProfitCenterId && this.selectedDepartmentId) {
        const payload: FetchShiftTemplateListPayload = {
          departmentId: this.selectedDepartmentId
        }

        const data: Array<ShiftTemplate> = await this.$store.dispatch(LOAD_SHIFT_TEMPLATE_LIST_FILTER, payload)
        this.shiftTemplateList = _.sortBy(data, [function(o) { return o.description.toLocaleLowerCase(); }])
      }

      if(routeData && routeData.companyData && routeData.companyData.selectedProfitCenterId && routeData.companyData.selectedDepartmentId && this.selectedProfitCenterId === routeData.companyData.selectedProfitCenterId && this.selectedDepartmentId === routeData.companyData.selectedDepartmentId) {
        this.selectedShiftTemplateId = routeData && routeData.companyData && routeData.companyData.selectedShiftTemplateId && this.shiftTemplateList.find((item: ShiftTemplate) => routeData.companyData.selectedShiftTemplateId === item.id) ? routeData.companyData.selectedShiftTemplateId : undefined
        this.selectedCalendarEventId = routeData && routeData.companyData && routeData.companyData.selectedCalendarEventId && this.calendarEventList.find((item: CalendarEvent) => routeData.companyData.selectedCalendarEventId === item.id) ? routeData.companyData.selectedCalendarEventId : undefined
        /*const selectedAddressId = routeData && routeData.companyData.selectedAddressId ? companyData.selectedAddressId : undefined
        if(selectedAddressId) {
          this.searchAddressById(selectedAddressId)
        } else {
          this.selectDefaultAddress()
        }*/
        /*if(this.$route.path === '/planning') {

          let data: any = undefined
          try {
            //@ts-ignore
            data = this.$route && this.$route.query && this.$route.query.data ? JSON.parse(this.$route.query.data) : {}
          } catch (e) {
            data = {}
          }

          data.companyData.selectedShiftTemplateId = this.selectedShiftTemplateId
          data.companyData.selectedCalendarEventId = this.selectedCalendarEventId
          data.companyData.selectedAddressId = this.selectedAddress ? this.selectedAddress.id : undefined

          this.$router.push({ name: 'planning', query: { data: JSON.stringify(data) } })
        }*/

        if(this.selectedProfitCenterId && routeData && routeData.companyData && routeData.companyData.selectedAddressId) {
          this.searchAddressById(routeData.companyData.selectedAddressId)
        }
        if(this.selectedShiftTemplateId) {
          this.onTemplateSelect(this.selectedShiftTemplateId)
        }
        if(this.selectedProfitCenterId && this.selectedCalendarEventId) {
          this.onCalendarEventSelect(this.selectedCalendarEventId)
        } else if (this.selectedProfitCenterId && this.calendarEventList[0]) {
          this.selectedCalendarEventId = this.calendarEventList[0].id
          this.onCalendarEventSelect(this.selectedCalendarEventId)
        }
      } else {
        this.$emit('templateChanged', undefined)
        this.selectedShiftTemplateId = undefined

        if(this.selectedProfitCenterId) {
          this.selectDefaultAddress()
        }
        if (this.selectedProfitCenterId && this.calendarEventList[0]) {
          this.selectedCalendarEventId = this.calendarEventList[0].id
          this.onCalendarEventSelect(this.selectedCalendarEventId)
        }
      }

      /*if (this.selectedProfitCenterId && this.calendarEventList[0]) {
        this.selectedCalendarEventId = this.calendarEventList[0].id
        this.onCalendarEventSelect(this.selectedCalendarEventId)
      }*/

      if(this.$route.path === '/planning') {
        routeData.companyData = {
          selectedProfitCenterId: this.selectedProfitCenterId,
          selectedDepartmentId: this.selectedDepartmentId,
          selectedAddressId: this.selectedAddress ? this.selectedAddress.id : undefined,
          selectedProjectId: this.selectedProject ? this.selectedProject.id : null,
          selectedShiftTemplateId: this.selectedShiftTemplateId,
          selectedCalendarEventId: this.selectedCalendarEventId
        }

        this.$router.push({ name: 'planning', query: { data: JSON.stringify(routeData) } })

        let schedulingData: any = this.$store.getters[SCHEDULING_GET_PARAMETERS]
        schedulingData.companyData = routeData.companyData
        this.$store.dispatch(SCHEDULING_SET_PARAMETERS, routeData)
      }
    },

    onTemplateSelect (templateId: number): void {
      const templateItem: ShiftTemplate = _.find(this.shiftTemplateList, { id: templateId })! as ShiftTemplate

      this.$emit('templateChanged', templateItem)

      if(this.$route.path === '/planning') {
        let data: any = this.getRouteData()

        data.companyData.selectedShiftTemplateId = this.selectedShiftTemplateId

        this.$router.push({ name: 'planning', query: { data: JSON.stringify(data) } })
      }
    },

    onAddressSelect (): void {
      this.$emit('selectedAddress', this.selectedAddress)
      this.selected = true

      if(this.$route.path === '/planning') {
        let data: any = this.getRouteData()

        data.companyData.selectedAddressId = this.selectedAddress ? this.selectedAddress.id : undefined

        this.$router.push({ name: 'planning', query: { data: JSON.stringify(data) } })
      }
    },

    onProjectSelect (): void {
      this.$emit('selectedProject', this.selectedProject)
      this.projectIsSelected = true

      if(this.$route.path === '/planning') {
        let data: any = this.getRouteData()

        data.companyData.selectedProjectId = this.selectedProject ? this.selectedProject.id : null

        this.$router.push({ name: 'planning', query: { data: JSON.stringify(data) } })
      }
    },

    async searchAddress(): Promise<void> {
      this.isLoading = true
      try {
        const data: Array<Address> = await this.$store.dispatch(SEARCH_ADDRESS_LIST, this.search)
        this.addressList = data
        this.isLoading = false
      } catch (e) {
        this.isLoading = false
      }
    },

    async searchProject(addressId: number): Promise<void> {
      this.projectLoading = true
      try {
        const response: PlanungLookupProjekteResponse = await this.$store.dispatch(PLANNING_SEARCH_PROJECT_LIST, addressId)
        if(response && !response.IsError && response.Data) {
          this.projectList = PlanningLookupProject.createListFromResponse(response.Data)
          this.projectLoading = false
        }
      } catch {
        this.projectLoading = false
      }
    },

    async searchAddressById (addressId: number): Promise<void> {
      const foundAddress: Array<Address> = await this.$store.dispatch(SEARCH_ADDRESS_BY_ID, addressId)
      if(foundAddress && foundAddress[0]) {
        this.selectedAddress = foundAddress[0]
        this.addressList = [this.selectedAddress]
        this.selected = true
        this.onAddressSelect()
      }
    },

    async selectDefaultAddress (): Promise<void> {
      if(this.foundProfitCenterData && this.foundProfitCenterData.addressId) {
        this.searchAddressById(this.foundProfitCenterData.addressId)
      } else {
        this.selectedAddress = undefined
      }
    },

    onCalendarEventSelect (calendarEventId: number): void {
      const calendarEventItem: CalendarEvent = _.find(this.calendarEventList, { id: calendarEventId })! as CalendarEvent
      this.$emit('calendarEventChanged', calendarEventItem)

      if(this.$route.path === '/planning') {
        let data: any = this.getRouteData()

        data.companyData.selectedCalendarEventId = this.selectedCalendarEventId

        this.$router.push({ name: 'planning', query: { data: JSON.stringify(data) } })
      }
    },

    getRouteData (): Object {
      let data: any = undefined
      try {
        //@ts-ignore
        data = this.$route && this.$route.query && this.$route.query.data ? JSON.parse(this.$route.query.data) : {}
      } catch (e) {
        data = {}
      }

      return data
    }
  }

})
